/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  room: {
    name: 'room',
    componentName: 'RoomContainer',
    chunk: () => import(
      /* webpackChunkName: "compare" */
      './pages/room/RoomContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/room/RoomContainer.js'))
          .RoomContainer
        : currentRouteName === 'room'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RoomContainer }))
          );
    },
    path: '/:context?/room/:param1?/:param2?/:param3?',
    channel: null
  },
  bath: {
    name: 'bath',
    componentName: 'BathRenovationContainer',
    chunk: () => import(
      /* webpackChunkName: "bath-renovation" */
      './pages/bath-renovation/BathRenovationContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/bath-renovation/BathRenovationContainer.js')
        ).BathRenovationContainer
        : currentRouteName === 'bath'
          ? currentRouteComponent
          : generateAsyncRoute(() => {
            return this.chunk().then((pageModule) => ({ default: pageModule.BathRenovationContainer }));
          });
    },
    path: '/:context?/bath-renovation/:param1?/:param2?/:param3?',
    channel: null
  },
  orangeLens: {
    name: 'orange-lens',
    componentName: 'OrangeLensContainer',
    chunk: () => import(
      /* webpackChunkName: "orange-lens" */
      './pages/orange-lens/OrangeLensContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/orange-lens/OrangeLensContainer.js')
        ).OrangeLensContainer
        : currentRouteName === 'orange-lens'
          ? currentRouteComponent
          : generateAsyncRoute(() => {
            return this.chunk().then((pageModule) => ({ default: pageModule.OrangeLensContainer }));
          });
    },
    path: '/:context?/orange-lens/:param1?/:param2?/:param3?',
    channel: null
  },
  browse: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/browse-search/BrowseAndSearchContainer'
    ),
    get component() {
      return ssr // eslint-disable-next-line max-len
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')
        ).BrowseAndSearchContainer
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer }))
          );
    },
    path: '/:context?/:bassPV?/b/*',
    channel: 'desktop'
  },

  browseMobile: {
    name: 'browse-and-search-mobile',
    componentName: 'BrowseAndSearchMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search-mobile" */
      './pages/browse-search/BrowseAndSearchMobileContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchMobileContainer.js')
        ).BrowseAndSearchMobileContainer
        : currentRouteName === 'browse-and-search-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.BrowseAndSearchMobileContainer
          }))
          );
    },
    path: '/:context?/b/*',
    channel: 'mobile'
  },

  search: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/browse-search/BrowseAndSearchContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')
        ).BrowseAndSearchContainer
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer }))
          );
    },
    path: '/:context?/s/*',
    channel: 'desktop'
  },

  searchMobile: {
    name: 'browse-and-search-mobile',
    componentName: 'BrowseAndSearchMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search-mobile" */
      './pages/browse-search/BrowseAndSearchMobileContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchMobileContainer.js')
        ).BrowseAndSearchMobileContainer
        : currentRouteName === 'browse-and-search-mobile'
          ? currentRouteComponent // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.BrowseAndSearchMobileContainer
          }))
          );
    },
    path: '/:context?/s/*',
    channel: 'mobile'
  },

  pep: {
    name: 'pep',
    componentName: 'PepDesktopContainer',
    chunk: () => import(
      /* webpackChunkName: "pep" */
      './pages/pep/PepDesktopContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pep/PepDesktopContainer.js'))
          .PepDesktopContainer
        : currentRouteName === 'pep'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepDesktopContainer }))
          );
    },
    path: '/:context?/pep/:slug?/:itemId',
    prefetch: ['product', 'compare'],
    channel: 'desktop'
  },

  // @TODO: Named export doesn't match the component file name.
  pepMobile: {
    name: 'pep-mobile',
    componentName: 'PepMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "pep-mobile" */
      './pages/pep/PepMobileContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pep/PepMobileContainer.js'))
          .PepMobileContainer
        : currentRouteName === 'pep-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepMobileContainer }))
          );
    },
    path: '/:context?/pep/:slug?/:itemId',
    prefetch: ['productMobile'],
    channel: 'mobile'
  },

  paintReorder: {
    name: 'paint-reorder',
    componentName: 'PaintReorderContainer',
    chunk: () => import(
      /* webpackChunkName: "paint-reorder" */
      './pages/paint-reorder/PaintReorderContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/paint-reorder/PaintReorderContainer.js'))
          .PaintReorderContainer
        : currentRouteName === 'paint-reorder'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.PaintReorderContainer })));
    },
    // p/paint/config/<configId>/<Brand>-<Size>-<Color-#>-<Sheen>/<BaseOMSID></BaseOMSID>
    path: '/:context?/p/paint/config/:configId/:slug?/:itemId',
    channel: 'desktop'
  },

  paintReorderMobile: {
    name: 'paint-reorder-mobile',
    componentName: 'PaintReorderMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "paint-reorder-mobile" */
      './pages/paint-reorder/PaintReorderMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/paint-reorder/PaintReorderMobileContainer.js')).PaintReorderMobileContainer
        : currentRouteName === 'paint-reorder-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.PaintReorderMobileContainer })));
    },
    path: '/:context?/p/paint/config/:configId/:slug?/:itemId',
    channel: 'mobile'
  },

  product: {
    name: 'product',
    componentName: 'ProductContainer',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/product/ProductContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductContainer.js'))
          .ProductContainer
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer }))
          );
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browse'],
    channel: 'desktop'
  },

  productMobile: {
    name: 'product-mobile',
    componentName: 'ProductMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "product-mobile" */
      './pages/product/ProductMobileContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/product/ProductMobileContainer.js')
        ).ProductMobileContainer
        : currentRouteName === 'product-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductMobileContainer }))
          );
    },
    path: '/:context?/p/:slug?/:itemId',
    prefetch: ['browseMobile'],
    channel: 'mobile'
  },

  collections: {
    name: 'collections',
    componentName: 'CollectionsContainer',
    chunk: () => import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "collections" */
      './pages/collections/CollectionsContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/collections/CollectionsContainer.js')
        ).CollectionsContainer
        : currentRouteName === 'collections'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CollectionsContainer }))
          );
    },
    path: '/:context?/collection/:category/:slug/:collectionId',
    channel: 'desktop'
  },

  collectionsMobile: {
    name: 'collections-mobile',
    componentName: 'CollectionsContainerMobile',
    chunk: () => import(
      /* webpackChunkName: "collections-mobile" */
      './pages/collections/CollectionsContainerMobile'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/collections/CollectionsContainerMobile.js')
        ).CollectionsContainerMobile
        : currentRouteName === 'collections-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.CollectionsContainerMobile }))
          );
    },
    path: '/:context?/collection/:category/:slug/:collectionId',
    channel: 'mobile'
  },
  vendorCollections: {
    name: 'vendor-collections',
    componentName: 'VendorCollectionsContainer',
    chunk: () => import(
      /* webpackChunkName: "vendor-collections" */
      './pages/vendor-collections/VendorCollectionsContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/vendor-collections/VendorCollectionsContainer.js')
        ).VendorCollectionsContainer
        : currentRouteName === 'vendor-collections'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.VendorCollectionsContainer }))
          );
    },
    path: '/:context?/collection/:category/:collectionName',
    channel: 'desktop'
  },

  vendorCollectionsMobile: {
    name: 'vendor-collections-mobile',
    componentName: 'VendorCollectionsContainerMobile',
    chunk: () => import(
      /* webpackChunkName: "vendor-collections-mobile" */
      './pages/vendor-collections/VendorCollectionsContainerMobile'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak(
            '@cwd/src/pages/vendor-collections/VendorCollectionsContainerMobile.js'
          )
        ).VendorCollectionsContainerMobile
        : currentRouteName === 'vendor-collections-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({
            default: pageModule.VendorCollectionsContainerMobile
          }))
          );
    },
    path: '/:context?/collection/:category/:collectionName',
    channel: 'mobile'
  },

  compare: {
    name: 'compare',
    componentName: 'CompareContainer',
    chunk: () => import(
      /* webpackChunkName: "compare" */
      './pages/compare/CompareContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/compare/CompareContainer.js'))
          .CompareContainer
        : currentRouteName === 'compare'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CompareContainer }))
          );
    },
    path: '/:context?/compare',
    channel: null
  },

  styleQuiz: {
    name: 'stylequiz',
    componentName: 'StyleQuizContainer',
    chunk: () => import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "stylequiz" */
      './pages/style-quiz/StyleQuizContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(
          require.resolveWeak('@cwd/src/pages/style-quiz/StyleQuizContainer.js')
        ).StyleQuizContainer
        : currentRouteName === 'stylequiz'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StyleQuizContainer }))
          );
    },
    path: '/:context?/stylequiz/:styleId?',
    channel: null
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home }))
          );
    },
    path: '/:context?/',
    channel: null
  }
});
